import { ShieldOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';

/**
 * Full-page denial view for a protected GET that answered 403 (design §16.4).
 * Copy is verbatim; no red styling, no dead controls.
 */
export function PolicyDeniedView() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center text-center">
      <ShieldOff className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
      <h2 className="mt-4 text-xl font-semibold tracking-tight">You don't have access</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        You don't have permission to view this. If you believe you should, ask an organization owner
        or admin.
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        <Button onClick={() => navigate('/')}>Go to dashboard</Button>
        <Button variant="outline" onClick={() => navigate(-1)}>
          Go back
        </Button>
      </div>
    </div>
  );
}
